export { LecturersList } from "./LecturersList";
